import React from "react";
import { Box, Button, Typography, Avatar } from "@mui/material";
import { fToNow } from "../../../utils/formatTime";
import { parseDateSafe, minuteBucket } from "../utils/grouping";

const EntryItemRow = ({
    item,
    order,
    isAddon,
    group,
    canAdvanceStatus,
    isMutating,
    onAdvanceItem,
    getItem,
    selectedCenters,
    classes,
    highlight,
}) => {
    const statusChangedAt = parseDateSafe(item.status_change_date);
    const groupMinute = typeof group.key === "number" ? group.key : minuteBucket(group.time);
    const statusMinute = minuteBucket(statusChangedAt);
    const showStatusChange = !!statusChangedAt && statusMinute !== groupMinute;
    const menuItem = getItem ? getItem(item.item_code) : null;

    let centerLabel = null;
    if (Array.isArray(selectedCenters) && selectedCenters.length > 1) {
        const ig = (item.item_group || "").trim();
        const match = selectedCenters.find((c) =>
            (c.production_center_group || []).some((g) => (g.item_group || "").trim() === ig)
        );
        centerLabel = match ? match.description || match.name : null;
    }

    return (
        <Button
            key={(item.name || "") + (item.identifier || "") + (isAddon ? "-addon" : "")}
            variant="outlined"
            onClick={() => onAdvanceItem(order, item)}
            disabled={isMutating || !canAdvanceStatus(item.status)}
            className={`${classes.ItemButton} ${highlight ? classes.ItemAdded : ""}`}
            sx={isAddon ? { pl: 4 } : undefined}
            style={{ width: "100%" }}
        >
            <Box className={classes.ItemButtonInner}>
                <Box className="left" style={{ display: "flex", gap: 8, alignItems: "center" }}>
                    {menuItem?.cover && (
                        <Avatar
                            variant="rounded"
                            src={menuItem.cover}
                            alt={item.item_name}
                            sx={{ width: 32, height: 32 }}
                        />
                    )}
                    <Typography variant="body1" className="name">
                        {item.item_name}
                    </Typography>
                    {centerLabel && (
                        <Typography variant="caption" className="meta">
                            • {centerLabel}
                        </Typography>
                    )}
                    {item.notes && String(item.notes).trim().length > 0 && (
                        <Typography variant="caption" className="notes">
                            {item.notes}
                        </Typography>
                    )}
                    <Typography variant="caption" className="qtyPill">
                        × {item.qty}
                    </Typography>
                </Box>
                {/* {showStatusChange && (
                    <Box sx={{ width: "100%" }}>
                        <Typography variant="caption" className="statusChange">
                            Updated {fToNow(statusChangedAt)}
                        </Typography>
                    </Box>
                )} */}
                {/* <Typography variant="button" className="action">
                    Done
                </Typography> */}
            </Box>
        </Button>
    );
};

export default EntryItemRow;


